import React from 'react';
import { FiMenu, FiSun, FiMoon, FiLogOut } from 'react-icons/fi';
import { useTheme } from '@/contexts/theme';
import { useAuth } from '@/contexts/AuthContext';
import { getInitials } from '@/lib/utils';

interface HeaderProps {
  sidebarCollapsed: boolean;
  onToggleSidebar: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { theme, toggleTheme } = useTheme();
  const { state, logout } = useAuth();
  const user = state.user;

  return (
    <header
      className="flex items-center justify-between h-[56px] px-4 border-b"
      style={{
        backgroundColor: 'var(--theme-header-background)',
        borderColor: 'var(--theme-header-border)',
      }}
    >
      {/* Left side: Menu button + Theme toggle */}
      <div className="flex items-center gap-1">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-lg transition-colors"
          style={{ color: 'var(--theme-header-text)' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--theme-header-button-hover)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
          title="Recolher menu"
        >
          <FiMenu className="h-[18px] w-[18px]" />
        </button>

        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg transition-colors"
          style={{ color: 'var(--theme-header-text)' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'var(--theme-header-button-hover)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
          title={theme === 'light' ? 'Tema escuro' : 'Tema claro'}
        >
          {theme === 'light' ? <FiMoon className="h-[18px] w-[18px]" /> : <FiSun className="h-[18px] w-[18px]" />}
        </button>
      </div>

      {/* Right side: User info + Logout */}
      <div className="flex items-center gap-2">
        {user && (
          <div className="flex items-center gap-3">
            <div
              className="flex items-center justify-center w-8 h-8 rounded-full text-xs font-semibold"
              style={{ backgroundColor: 'var(--theme-primary-background)', color: 'var(--theme-primary)' }}
            >
              {getInitials(`${user.firstName} ${user.lastName}`)}
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-medium leading-tight" style={{ color: 'var(--theme-header-text)' }}>
                {user.firstName} {user.lastName}
              </p>
              <p className="text-xs leading-tight" style={{ color: 'var(--theme-muted-text)' }}>
                {user.email}
              </p>
            </div>
          </div>
        )}

        <div className="w-px h-6 mx-1" style={{ backgroundColor: 'var(--theme-border)' }} />

        <button
          onClick={logout}
          className="p-2 rounded-lg transition-colors"
          style={{ color: 'var(--theme-muted-text)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--theme-header-button-hover)';
            e.currentTarget.style.color = 'var(--theme-error-color)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'var(--theme-muted-text)';
          }}
          title="Sair"
        >
          <FiLogOut className="h-[18px] w-[18px]" />
        </button>
      </div>
    </header>
  );
};
